import { render, staticRenderFns } from "./RealEstateModal.vue?vue&type=template&id=da84bb94&"
import script from "./RealEstateModal.vue?vue&type=script&lang=js&"
export * from "./RealEstateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports